var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-end"},[_c('button',{staticClass:"btn btn-thin me-3",on:{"click":_vm.goToLogin}},[_vm._v(_vm._s(_vm.$t('button.login')))]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.goToCreateAccount}},[_vm._v(_vm._s(_vm.$t('button.createAccount')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }